import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";

import { HasValue } from "../../../sharedCode/HelperMethods";
import { TicketExtended } from "../../../Utils/TypeExtensions";

// TODO - have to filter the list to just the charges relevant for this form
export default function NotesMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const details = <Typography textAlign={"center"}>{HasValue(ticket.comments) ? "CLICK TO SEE NOTES." : ""}</Typography>;
    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
